import { React, useEffect, useState, useRef } from "react";
import {getAlarmes} from "../../API/getAlarmes";
import LogoImage from "../../assets/img/logo.png";
import GestaoIcon from "../../assets/svg/gestaoIcon";
import roboWhite from "../../assets/img/robot-white.png";
import roboBlack from "../../assets/img/robot-black.png";
import CadeadoBlack from "../../assets/svg/cadeado-black";
import PlusIcon from "../../assets/svg/plusIcon";
import alameSound from "../../assets/sound/alarmeSound.mp3";
import "../../styles/desktop/menu.css";

import Status from "../status/status";

function Menu({
  trocarPagina,
  trocarImagem,
  paginas,
  paginaAtual,
}) {

  const [alarmes, setAlarmes] = useState([]);
  const [alarmeAtivo, setAlarmeAtivo] = useState(false);
  const audioRef = useRef(new Audio(alameSound));

  // Estado para controlar o menu expandido
  const [menuExpandidoIluminacao, setmenuExpandidoIluminacaoIluminacao] = useState(false);
  const [menuExpandidoPlus, setmenuExpandidoPlus] = useState(false);


  const climatizacaoBloqueado = true; // Altere para a lógica necessária
  const plusLocked = false; // Altere para a lógica necessária

  useEffect(() => {
    const interval = setInterval(() => {
      getAlarmes().then((data) => {
        setAlarmes(data);
      });
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (alarmes.some((alarme) => alarme.status)) {
      if (sessionStorage.getItem("alertaDesativado")) {
        setAlarmeAtivo(true);
        stopAlarme();
        return;
      }
      trocarPagina("Alarme");
      setAlarmeAtivo(true);
      playAlarme();
      setTimeout(() => {
        alert("Alarme disparado!");
        const desativarAlert = window.confirm("Deseja desativar temporariamente o alerta de alarme?");
        if (desativarAlert) {
          stopAlarme();
          desativarAlertaTemporariamente();
        }
      }, 600);
    } else {
      setAlarmeAtivo(false);
    }
  }, [alarmes, trocarPagina]);

  const desativarAlertaTemporariamente = () => {
    const alertKey = 'alertaDesativado';
    const expirationTime = 60 * 60000;
    const expirationDate = new Date().getTime() + expirationTime;
    sessionStorage.setItem(alertKey, expirationDate);
    setTimeout(() => {
      sessionStorage.removeItem(alertKey);
      setAlarmeAtivo(false);
    }, expirationTime);
  };

  const playAlarme = () => {
    audioRef.current.play();
    audioRef.current.volume = 0.4;
    audioRef.current.loop = true;
  };

  const stopAlarme = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  };

  const expandMenuIluminacao = () => {
    console.log("Menu expandido");
    setmenuExpandidoIluminacaoIluminacao(!menuExpandidoIluminacao);
  };

  const expandMenuExpandidoPlus = () => {
    console.log("Menu expandido");
    setmenuExpandidoPlus(!menuExpandidoPlus)
  };

  return (
    <nav className="menu">
      <div id="barraDeOpções">
        <img src={LogoImage} alt="Logo" id="logo" />
        <div id="barraDeOpções-Botoes">
          <button
            className={`btn ${paginaAtual === "Térreo" || paginaAtual === "Lazer 1" || paginaAtual === "Lazer 2" ? "active" : ""}`}
            onClick={() => {
              expandMenuIluminacao();
              console.log("Botão Iluminação clicado, estado do menuExpandidoIluminacao:", menuExpandidoIluminacao);
            }}
          >
            Iluminação
          </button>
          {/* Submenu flutuante */}
          {menuExpandidoIluminacao && (
            <div className="submenu-iluminacao expandido">
              <button
                className={`btn ${paginaAtual === "Térreo" ? "active" : ""}`}
                onClick={() => {
                  trocarImagem(paginas[0]);
                  trocarPagina("Térreo");
                  expandMenuIluminacao();
                  if(menuExpandidoPlus){expandMenuExpandidoPlus()};
                }}
              >
                Térreo
              </button>
              <button
                className={`btn ${paginaAtual === "Lazer 1" ? "active" : ""}`}
                onClick={() => {
                  trocarImagem(paginas[1]);
                  trocarPagina("Lazer 1");
                  expandMenuIluminacao();
                  if(menuExpandidoPlus){expandMenuExpandidoPlus()};
                }}
              >
                Lazer 1
              </button>
              <button
                className={`btn ${paginaAtual === "Lazer 2" ? "active" : ""}`}
                onClick={() => {
                  trocarImagem(paginas[2]);
                  trocarPagina("Lazer 2");
                  expandMenuIluminacao();
                  if(menuExpandidoPlus){expandMenuExpandidoPlus()};
                }}
              >
                Lazer 2
              </button>
            </div>
          )}
          <button className={`btn ${paginaAtual === "Exaustor" ? "active" : ""}`} 
            onClick={() => {
              trocarPagina("Exaustor");
              if(menuExpandidoPlus){expandMenuExpandidoPlus()};
              if(menuExpandidoIluminacao){expandMenuIluminacao()};
            }}
          >
            Exaustores
          </button>
          <button
            className={`btn ${paginaAtual === "Climatização" ? "active" : ""} ${climatizacaoBloqueado ? "bloqueado" : ""}`}
            onClick={() => {
              if (!climatizacaoBloqueado) {
                trocarPagina("Climatização");
                if(menuExpandidoPlus){expandMenuExpandidoPlus()};
                if(menuExpandidoIluminacao){expandMenuIluminacao()};
              }
            }}
            disabled={climatizacaoBloqueado} // Desabilita a interação com o botão
          >
            Climatização
            {climatizacaoBloqueado && (
              <span className="icon-cadeado">
                <CadeadoBlack/>
              </span>
            )}
          </button>
          <button className={`btn ${paginaAtual === "Agendamentos" ? "active" : ""}`} 
            onClick={() => {
              trocarPagina("Agendamentos");
              if(menuExpandidoPlus){expandMenuExpandidoPlus()};
              if(menuExpandidoIluminacao){expandMenuIluminacao()};
            }}
          >
            Agendamentos
          </button>
          <button
            className={`btn ${alarmeAtivo ? "activoAlert" : (paginaAtual === "Alarme" ? "active" : "")}`}
            onClick={() => {
              trocarPagina("Alarme");
              if(menuExpandidoPlus){expandMenuExpandidoPlus()};
              if(menuExpandidoIluminacao){expandMenuIluminacao()};
            }}
          >
            Monitoramento
          </button>
          <button
            className={`btn ${paginaAtual === "history" ? "active" : ""}`}
            onClick={() => {
              trocarPagina("history");
              if(menuExpandidoPlus){expandMenuExpandidoPlus()};
              if(menuExpandidoIluminacao){expandMenuIluminacao()};
            }}
          >
            Registros
          </button>
          <button className={`btn ${paginaAtual === "Gestao" ? "active" : ""}`} 
            onClick={() => {
              trocarPagina("Gestao");
              if(menuExpandidoPlus){expandMenuExpandidoPlus()};
              if(menuExpandidoIluminacao){expandMenuIluminacao()};
            }}
          >
            Gestão
            <GestaoIcon
              className="IconeMenu"
              width="20"
              height="20"
              fill={paginaAtual === "Gestao" ? "#ffffff" : "#000000"} // Muda a cor do ícone dinamicamente
            />
          </button>
          <button
            className="btn invisivel"
            disabled
            aria-hidden="true" // Torna invisível para leitores de tela
          >
            
          </button>
          <button
            className={`btn plus-btn ${paginaAtual === "PLUS" ? "active" : ""}`}
            onClick={() => {
              trocarPagina("PLUS");
              if(menuExpandidoIluminacao){expandMenuIluminacao()};
              if(menuExpandidoPlus){expandMenuExpandidoPlus()};
            }}
          >
            PLUS
            <PlusIcon
              className="PlusIcon" 
              width="25" 
              height="25" />
          </button>
          <button
            className={`btn ${paginaAtual === "Chatbot" ? "active" : ""} ${plusLocked ? "bloqueado" : ""}`}
            onClick={() => {
              if (!plusLocked) {
                trocarPagina("Chatbot");
                if (menuExpandidoIluminacao) expandMenuIluminacao();
                if(menuExpandidoPlus){expandMenuExpandidoPlus()};
              }
            }}
            disabled={plusLocked} // Desabilita a interação com o botão
          >
            Chatbot
            <img
              src={paginaAtual === "Chatbot" ? roboWhite : roboBlack} // Altera o ícone conforme o estado
              alt="Robo"
              id={`robo-icon`}
            />
            {plusLocked && (
              <span className="icon-cadeado">
                <CadeadoBlack width="25" height="25" />
              </span>
            )}
          </button>

          <button
            className={`btn ${paginaAtual === "Recursos" ? "active" : "" || paginaAtual === "Dispositivos" ? "active" : ""} ${plusLocked ? "bloqueado" : ""}`}
            onClick={() => {
              if (!plusLocked) {
                  expandMenuExpandidoPlus();
                  if(menuExpandidoIluminacao){expandMenuIluminacao()};
              }
            }}
            disabled={plusLocked} // Desabilita a interação com o botão
          >
            Recursos Extras
            {plusLocked && (
              <span className="icon-cadeado">
                <CadeadoBlack width="25" height="25" />
              </span>
            )}
          </button>
          {menuExpandidoPlus && (
            <div className="submenu-plus expandido">
              <button className={`btn ${paginaAtual === "Dispositivos" ? "active" : ""}`} 
                onClick={() => {
                  if (!plusLocked) {
                    trocarPagina("Dispositivos");
                    expandMenuExpandidoPlus();
                    if (menuExpandidoIluminacao) expandMenuIluminacao();
                  }
                }}
              >
                Dispositivos
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="statusObject">
        <Status />
      </div>
    </nav>
  );
}

export default Menu;
